module.exports = __webpack_public_path__ + "static/media/logo-2.055d31bea6e2796b1a44f2c9edd338f6.png";